import { IMacro } from 'Models/docas'

import { IComentario, IAlertaOcorrencia } from '.'

export default interface IHorario {
  cdAgendamendoDocasDocas: number
  cdAgendamentoDocasJanela: number
  cdAgendamentoDocasHorario: number
  cdPontoEntidade: number
  cdCandidatoAgendamento?: number
  dtHora: string
  hora: string
  horarioStatus: number
  cdVeiculo: number
  cdViagem: number
  documentoViagem?: string
  origemViagem?: string
  destinoViagem?: string
  documento?: string
  justificativa: string
  confirmado: boolean
  versao: string
  comentarios: IComentario[]
  temComentario: boolean
  temMacro: boolean
  temAlerta: boolean
  nomeMotorista: string
  cdEntidade: number
  nomeEntidade: string
  nomeTransportadora: string
  placa: string
  macrosCandidato: IMacro[]
  cdMacro: number
  nomeMacro: string
  dtHoraMacroStr: string
  cdMacroUsuario: number
  cdMacroExcetoOutros: number
  cdMacroUsuarioExcetoOutros: number
  corMacro?: string
  peso?: string
  piscar: boolean
  alertas: IAlertaOcorrencia[]
  ultimasMacros: IMacro[]
  nomeUsuario?: string
  nomeJanela: string
  nomeDoca: string
  dadosViagem: string
  observacaoCandidato?: string
}

export const STATUS_HORARIOS = {
  LIVRE: 0, // Cinza
  RESERVADO: 1, // Azul
  APROVADO: 2, // verde
  CANCELADO: 3, // tratar como se fosse livre
  BLOQUEADO: 4, // Vermelho
  NO_SHOW: 5, // não definido
  RESERVADO_APROVADO: 6,
}
